import { useEffect, useState } from 'react';
import { reservationUrl } from './navigationConfig.js';

const FloatingReservationButton = ({
    label = 'ご予約はこちら',
    intersectionTargetRef,
    className = ''
}) => {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const targetEl = intersectionTargetRef?.current;

        if (!targetEl) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHidden(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        observer.observe(targetEl);

        return () => {
            observer.disconnect();
        };
    }, [intersectionTargetRef]);

    const classes = `floating-reservation-button${isHidden ? ' floating-reservation-button--hidden' : ''}${
        className ? ` ${className}` : ''
    }`;

    return (
        <a
            className={classes}
            href={reservationUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
        >
            {label}
        </a>
    );
};

export default FloatingReservationButton;

